// extracted by mini-css-extract-plugin
export default {"addButton":"UploadFont_addButton__Qq0+R","formItem":"UploadFont_formItem__Vw5uv","upload":"UploadFont_upload__mlN+Z"};